@import "src/styles/variabels";

.root {
  overflow: auto;
  position: relative;
  height: 100%;
  width: 100%;
  // Momentum scroll on touch (older iOS Safari; a no-op elsewhere). Phase F1.
  // No `overscroll-behavior: contain` (BF-02): below md the box grows to its content and never scrolls, so contain blocked the swipe from chaining to the page.
  @media (hover: none) and (pointer: coarse) {
    -webkit-overflow-scrolling: touch;
  }
  &::-webkit-scrollbar {
    width: 0.6rem;
    height: 0.6rem;
    background-color: transparent;
    border-radius: 0.6rem;
    cursor: pointer;
  }

  &::-webkit-scrollbar-track {
    border-radius: 0.4rem;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0.7rem;
    background-color: transparent;
  }
}
.visible {
  &::-webkit-scrollbar {
    background-color: rgba(gray, 0.2);
  }
  &::-webkit-scrollbar-track {
    background-color: rgba($color-table, .1);
  }
  &::-webkit-scrollbar-thumb {
    background-color: $color-secondary;
    &:hover {
      background-color: $color-secondary;
    }
  }
}
.hover {
  &:hover {
    &::-webkit-scrollbar {
      background-color: rgba(gray, 0.2);
    }
    &::-webkit-scrollbar-track {
      background-color: rgba($color-table, .1);
    }
    &::-webkit-scrollbar-thumb {
      background-color: $color-secondary;
      &:hover {
        background-color: $color-secondary;
      }
    }
  }
}
